import Drawer from '@mui/material/Drawer';
import * as React from 'react';
import { cn } from '../../../../utils';

export default function MuiDrawer({
  open,
  onCloseHandler,
  children,
  anchor = 'bottom',
  overBottomNav = false,
}) {
  return (
    <Drawer
      anchor={anchor}
      open={open}
      className={overBottomNav ? 'z-[2000]' : ''}
      onClose={onCloseHandler}
    >
      <div className={cn(overBottomNav && 'z-[2000]' , 'mb-[103px]  h-[80%]')}>
        {children}
      </div>
    </Drawer>
  );
}
